import { apiClient } from './axios';

import type {
  PaginatedResponse,
  ScheduledWorkflowRunQuery,
  ScheduledWorkflowRunWithRelations,
} from '@repo/shared-types';

export const scheduledWorkflowRunsApi = {
  getAll: async (query: Partial<ScheduledWorkflowRunQuery> = {}) => {
    const res = await apiClient.get<PaginatedResponse<ScheduledWorkflowRunWithRelations>>(
      '/scheduled-workflow-runs',
      { params: query },
    );
    return res.data;
  },
  cancel: async (id: string) => {
    const res = await apiClient.post<{ cancelled: boolean }>(
      `/scheduled-workflow-runs/${id}/cancel`,
    );
    return res.data;
  },
};
